$.fn.SeeMore = function(limit) {
  let self = this
  self.limit = limit
  self.minHeight = 0;

  if (self.find('.grid__item').length > self.limit) {
    if ($('html').attr('lang') == 'fr-CA') {
      var see_more_label = 'Voir plus'
    } else {
      var see_more_label = 'See more'
    }
    self.moreButton = $('<div class="text-content see-more-toggle mt-1"><div class="btn-primary__wrapper"><a class="btn-primary js-see-more">' + see_more_label + '</a></div></div>')
    self.after(self.moreButton);
    self.wrap('<div class="see-more"></div>');
    self.wrapper = self.closest('.see-more')

    self.moreButton.click(function() {
      self.wrapper.addClass('--extended')
    })

  }

  self.init = function() {
    if (self.find('.grid__item').length > self.limit) {
      self.minHeight = 0;
      self.find('.grid__item').each(function(index) {
        if (index + 1 <= self.limit) {
          self.minHeight += $(this).outerHeight();
          self.minHeight += parseInt(self.css('grid-row-gap'))
        }
      })
      self.wrapper.css('--minHeight', self.minHeight + 'px')
      self.wrapper.css('--maxHeight', self.outerHeight() + 'px')
    }
  }

  return function() {
    $(window).on('resize load orientationchange', self.init)
    return self
  }()
}
